import React from 'react'
import { Translation, Translator } from '@morningtrain/react-translations'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import * as Displays from 'support/displays'
import MessageRecipient from 'widgets/smartviews/hr/messages/MessageRecipient'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import { SpaceBetween } from 'ui'
import * as UI from 'ui'

export default function ViewMessage () {
  return (
    <Translator namespace='smartviews.message'>
      <SmartviewTextGroup>
        <SmartviewText>
          <SpaceBetween>
            <span><Translation name='fields.type.label' /></span>
            <Displays.Enum name='type' enum='message_type' />
          </SpaceBetween>
          <SpaceBetween>
            <span><Translation name='fields.is_forced.label' /></span>
            <Displays.Boolean name='is_forced' />
          </SpaceBetween>
          <SpaceBetween>
            <span><Translation name='fields.expires_at.label' /></span>
            <Displays.Date name='expires_at' />
          </SpaceBetween>
          <SpaceBetween>
            <span><Translation name='fields.show_from.label' /></span>
            <Displays.Date name='show_from' />
          </SpaceBetween>
        </SmartviewText>
      </SmartviewTextGroup>

      <Displays.Html name='content' className='p-4 bg-gray-100 whitespace-pre-wrap break-words' />

      <SmartviewContentSeparator />

      <ValueToCollection name='grouped_transactions'>
        <UI.VerticalList>
          <ForEachModel>
            <div>
              <UI.SpaceBetween>
                <span className='py-2'>
                  <UI.Text weight='medium' size='xl'>
                    <Displays.Text name='key' />
                  </UI.Text>
                </span>
                <span><Displays.Text name='delivered' /> / <Displays.Text name='total' /></span>
              </UI.SpaceBetween>
              <ValueToCollection name='collection'>
                <ForEachModel>
                  <UI.Collapsable gradient={false} maxHeight={40}>
                    <UI.SpaceBetween style={{ height: 40 }}>
                      <span className='py-2'>
                        <UI.Text weight='medium' size='base'>
                          <Displays.Text name='key' />
                        </UI.Text>
                      </span>
                      <span><Displays.Text name='delivered' /> / <Displays.Text name='total' /></span>
                    </UI.SpaceBetween>
                    <ValueToCollection name='collection'>
                      <ForEachModel>
                        <MessageRecipient />
                      </ForEachModel>
                    </ValueToCollection>
                  </UI.Collapsable>
                </ForEachModel>
              </ValueToCollection>
            </div>
          </ForEachModel>
        </UI.VerticalList>
      </ValueToCollection>
    </Translator>
  )
}
